import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { SectionHeading } from "components/misc/Headings.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { ReactComponent as SvgDecoratorBlob3 } from "images/svg-decorator-blob-3.svg";

const Heading = tw(SectionHeading)``;
const ThreeColumnContainer = styled.div`
  ${tw`mt-10 flex flex-col items-center lg:items-stretch lg:flex-row flex-wrap lg:justify-center max-w-screen-lg mx-auto`}
`;
const Column = styled.div`
  ${tw`lg:w-1/3 max-w-xs`}
`;

const Card = styled.a`
  ${tw`flex flex-col items-center text-center h-full mx-4 px-4 py-8 rounded transition-transform duration-300 hover:cursor-pointer transform `}
  .imageContainer {
    ${tw`text-center rounded-full p-4 bg-gray-100`}
    img {
      ${tw`w-8 h-8`}
    }
  }

  .title {
    ${tw`mt-4 font-bold text-xl leading-none`}
  }

  .description {
    ${tw`mt-4 text-sm font-medium text-secondary-300`}
  }

  .link {
    ${tw`mt-auto inline-flex items-center pt-5 text-sm font-bold text-primary-300 leading-none hocus:text-primary-900 transition duration-300`}
    .icon {
      ${tw`ml-2 w-4`}
    }
  }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-40`}
`;

export default ({
  lang,
  cards = [
    {
      imageSrc: "http://fhmetal.se/image/skill.png",
      title: "Bring in New Business Skills",
      title_se: "Få in nya affärsförmågor",
    },
    {
      imageSrc: "http://fhmetal.se/image/money.png",
      title: "Save Time, Money and Stress",
      title_se: "Spara tid, pengar och stress",
    },
    {
      imageSrc: "http://fhmetal.se/image/goal.png",
      title: "Prompt Employees to Reach Goals",
      title_se: "Be anställda att nå mål",
    },
    {
      imageSrc: "http://fhmetal.se/image/commodity.png",
      title: "Take Advantage of Valuable Resources",
      title_se: "Dra fördel av värdefulla resurser",
    },
    {
      imageSrc: "http://fhmetal.se/image/leader.png",
      title: "Gain an Outside Perspective",
      title_se: "Få ett perspektiv utanför",
    },
    {
      imageSrc: "http://fhmetal.se/image/manager.png",
      title: "Expertise in Business Management",
      title_se: "Kompetens inom företagsledning",
    },
  ],
  imageContainerCss = null,
  imageCss = null,
}) => {
  return (
    <Container>
      <ContentWithPaddingXl>
        <Heading style={{ color: "#666666" }}>
          {lang === "se"
            ? "Fördelarna med att få Business Consulting"
            : "Benefits of get Business Consulting"}
        </Heading>
        <ThreeColumnContainer>
          {cards.map((card, i) => (
            <Column key={i}>
              <Card href={card.url} style={{ cursor: "default" }}>
                <span
                  className="imageContainer"
                  css={imageContainerCss}
                  style={{ backgroundColor: "#ffede5" }}
                >
                  <img
                    src={card.imageSrc}
                    alt=""
                    css={imageCss}
                    style={{ width: "3rem", height: "3rem" }}
                  />
                </span>
                <span className="title" style={{ color: "#666666" }}>
                  {lang === "se" ? card.title_se : card.title}
                </span>
              </Card>
            </Column>
          ))}
        </ThreeColumnContainer>
      </ContentWithPaddingXl>
      <DecoratorBlob />
    </Container>
  );
};
